export class CertificadosObservacoesModel {
  id_observacao: number;
  nome: string;
  observacao: string;
}



// WEBPACK FOOTER //
// ./src/app/certificados_observacoes/certificados-observacoes.model.ts